import { Action } from "redux";

export const GET_PLAN_LIST_FOR_ORGANIZATION =
  "SUBSCRIPTION:GET_PLAN_LIST_FOR_ORGANIZATION";

export interface GetPlanListForOrganizationAction extends Action {
  type: typeof GET_PLAN_LIST_FOR_ORGANIZATION;
  organizationKeyName: string;
}

export const getPlanListForOrganizationAction = (
  organizationKeyName: string
): GetPlanListForOrganizationAction => ({
  type: GET_PLAN_LIST_FOR_ORGANIZATION,
  organizationKeyName,
});
